import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAppContext } from "../../contexts/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Css/style.css";
const Login = () => {
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { backendUrl, setAdminStatus, isAdmin, decodeAndSetUser } = useAppContext();
  const registrationRoute = "/users/login";
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token && isAdmin) {
      navigate("/admin");
    }
  }, [navigate, isAdmin]);
  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        `${backendUrl}${registrationRoute}`,
        credentials
      );
      // Assuming the response contains a token that can be used for authentication
      localStorage.removeItem("token");
      localStorage.setItem("token", res?.data?.token);

      // Decode token to set loggedUser and admin status in context immediately
      if (decodeAndSetUser) {
        decodeAndSetUser(res?.data?.token);
      } else {
        setAdminStatus(true);
      }

      // Redirect to the admin page
      navigate("/admin");
    } catch (err) {
      setError("Invalid credentials");
    }
  };

  return (
    <div
      className="container  d-flex flex-column justify-content-start mt-5  align-items-center"
      style={{ height: "100vh" }}
    >
      <div className="login-form">
        <h2 className="d-flex justify-content-center">Login</h2>
        {error && <div className="alert alert-danger">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <input
              type="email"
              name="email"
              className="form-control"
              placeholder="Email"
              value={credentials?.email}
              onChange={handleChange}
            />
          </div>
          <div className="mb-3">
            <input
              type="password"
              name="password"
              className="form-control"
              placeholder="Password"
              value={credentials?.password}
              onChange={handleChange}
            />
          </div>
          <button type="submit" className="btn btn-primary w-100">
            Login
          </button>
          {/* <div>
            <Link to="/register" className="d-flex justify-content-center m-2">
              Forgot Password
            </Link>
          </div>
          <div>
            <Link to="/register" className="d-flex justify-content-center ">
              Already Have An Account
            </Link>
          </div> */}
        </form>
      </div>
    </div>
  );
};

export default Login;
